import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Review } from '../../models/review';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { CourseService } from '../../services/course.service';
import { BehaviorSubject, Subject } from '../../../../node_modules/rxjs';

@Component({
  selector: 'app-my-review',
  templateUrl: './my-review.component.html',
  styleUrls: ['./my-review.component.scss']
})

export class MyReviewComponent implements OnInit {
  @Input('review') public review: Review;
  @Input('courseid') course_id:number;

  @Output('reviewed') reviewed = new Subject<Review>();
  @Output() parentToggleQuizOn = new EventEmitter();

  public reviewForm: FormGroup;
  public successMessage = null;
  public errors = [];

  public savingReview: boolean = false;
  public editReview: boolean = false;

  constructor(private courseService: CourseService) {
  }

  ngOnInit() {
    if(!this.review.id){
      this.review = new Review();
      this.review.course_id = this.course_id;
      this.review.rating=0;
      this.editReview = true;
    }

    this.reviewForm = new FormGroup({
      'review': new FormControl(this.review.review)
    });
  }

  saveReview(){
    this.errors =[];
    if(this.review.rating){
      this.savingReview = true;
      this.successMessage = null;
      this.review.review = this.reviewForm.get('review').value;
      this.courseService.postReview(this.review).subscribe(review=>{
        this.savingReview = false;
        this.successMessage = 'Review saved successfully';
        this.toggleEdit();
        this.reviewed.next(review);
      })
      this.parentToggleQuizOn.emit();
    }
    else{
      this.errors.push('You must provide a rating');
    }
  }

  toggleEdit(){
    this.successMessage = null;
    this.errors = [];

    this.editReview = (this.editReview ? false : true);
  }

  setRating(rating:number){
    this.review.rating = rating;
  }
}
